import { CommentCard } from "./CommentCard";
import { RecordingObjectType } from "../../../enums";
import { TypeOrRecord } from "../../TypeOrRecord";
import { Skeleton } from "antd";
import { useCollaborative, Comment } from "../use-collaborative";
import { CardThread } from "./comment-card.style";

interface CommentsListProps {
  /** Persisted comments (topics: output.comments) — used only for the loading skeleton gate. */
  comments?: Comment[];
  /** When true (topics streaming), skip the loading skeleton. */
  isStreaming?: boolean;
  /** Whether the current user may author comments / replies. */
  canComment?: boolean;
  /** Whether to show the resolve/reopen control (building blocks only). */
  canResolve?: boolean;
}

export const CommentsList = ({
  comments,
  isStreaming = false,
  canComment = true,
  canResolve = false
}: CommentsListProps) => {
  const {
    localComments,
    setActiveComment,
    activeComment,

    getComment,
    updateComment,
    createComment,

    commentsInEditMode,

    isSynced
  } = useCollaborative();

  if (!isSynced && !isStreaming && comments?.length > 0) {
    return <Skeleton active paragraph={{ rows: 4 }} />;
  }

  return (
    <>
      {localComments
        ?.filter((c) => !c.parentComment && !c.isOrphaned)
        .map((c) => {
          const isSelected = activeComment?.id === c.id;

          return (
            <div
              id={c.id}
              data-thread-id={c.id}
              key={c.id}
              onClick={(e) => {
                e.stopPropagation();

                if (
                  !commentsInEditMode.includes(c.id) &&
                  !c.subComments?.some((scId: string) =>
                    commentsInEditMode.includes(scId)
                  )
                ) {
                  setActiveComment(c);
                }
              }}
            >
              <CardThread active={isSelected.toString()}>
                <CommentCard comment={c} canComment={canComment} canResolve={canResolve} />
                {c.subComments
                  ?.filter((scId) => !!getComment(scId))
                  .map((scId) => {
                    return (
                      <div key={scId} id={scId}>
                        <CommentCard
                          comment={getComment(scId)}
                          canComment={canComment}
                        />
                      </div>
                    );
                  })}
                {isSelected && canComment && (
                  <div
                    style={{
                      marginLeft: "4px",
                      marginRight: "4px"
                    }}
                  >
                    <TypeOrRecord
                      disabled={false}
                      recordingObjectType={RecordingObjectType.OUTPUT_COMMENT}
                      onProcess={async (transcript: string, _: string) => {
                        if (c.text) {
                          createComment({
                            parentId: c.id,
                            text: transcript,
                            refText: c.refText,
                            fromRel: c.fromRel,
                            toRel: c.toRel,
                            fromAbs: null,
                            toAbs: null
                          });
                        } else {
                          updateComment(c.id, transcript);
                        }

                        setActiveComment(null);
                      }}
                      submitButtonText={"Save"}
                      clearTextOnSubmit={false}
                      placeHolder="Add comment"
                    />
                  </div>
                )}
              </CardThread>

              <br />
            </div>
          );
        })}
    </>
  );
};
